import { useEffect } from 'react'
import { create } from 'zustand'

import { initLogger } from '@/lib/logger.ts'

const logger = initLogger('App Updater')

interface UpdateAppState {
  hadUpdateAt?: Date | null
  setHadUpdateAt: (hadUpdateAt: Date) => void
}

export const useAppUpdateStore = create<UpdateAppState>((set) => ({
  hadUpdateAt: null,
  setHadUpdateAt: (hadUpdateAt: Date) => set(() => ({ hadUpdateAt })),
}))

export const useUpdateApp = (
  {
    couldUpdate,
    beforeUpdate,
  }: {
    couldUpdate?: boolean
    beforeUpdate?: (...args: Array<unknown>) => unknown
  } = { couldUpdate: true }
) => {
  const store = useAppUpdateStore()

  useEffect(() => {
    if (couldUpdate && store.hadUpdateAt) {
      ;(async () => {
        logger.info('Updating App')
        await (async () => beforeUpdate?.())().catch(() => {})
        window.location.reload()
      })()
    }
  }, [beforeUpdate, couldUpdate, store.hadUpdateAt])
}
